"use client"

import { useEffect } from "react";
import { Crisp } from "crisp-sdk-web";

const CrispChat = () => {
  useEffect(() => {
    Crisp.configure("39156c2c-e5f3-486c-8c6a-352687e41078");
  });

  return null;
}

export default CrispChat;